export default {"src":"/_next/static/media/google-rating.a3b62216.svg","height":112,"width":170,"blurWidth":0,"blurHeight":0};